// extracted by mini-css-extract-plugin
module.exports = {"button":"_1spaC","icon":"_1dm9q"};